import React from "react"
import styled, { css } from "styled-components"

import RatingCard from "./rating-card"
import Confetti from "./confetti"
import { Button, getMediaQueries } from "@abmg-components"

// const size = {
//   tablet: 850,
//   mobile: 600,
// }
// const below = Object.keys(size).reduce((acc, label) => {
//   acc[label] = (...args) => css`
//     @media (max-width: ${size[label]}px) {
//       ${css(...args)};
//     }
//   `
//   return acc
// }, {})

const { below } = getMediaQueries()

const Header = styled.header`
  max-width: 1248px;
  padding: 0 48px;
  margin: 16px auto 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  ${below.tablet`
    flex-direction: column;
  `}
  ${below.mobile`
    padding: 0 24px;
  `}

  h1 {
    margin-bottom: 8px;
    ${below.mobile`
    font-size: 40px;
    line-height: 56px;
    `}
  }
  .subtitle {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    color: var(--grey);
    letter-spacing: 0.01rem;
    max-width: 525px;
  }

  div {
    flex: 1;
    &.rating {
      position: relative;
      min-height: 320px;
      display: flex;
      align-items: center;
    }
  }
`
const Headlines = styled.div`
  flex: 1;
  min-width: 460px;
  ${below.tablet`
min-width: initial;
margin-bottom: 24px;
`}
`
const ConfettiWrapper = styled.div`
  position: absolute;
  width: 100%;
  min-width: 550px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
`

const ReviewHeader = ({ bankerData, ratingData }) => {
  return (
    <Header>
      <Headlines>
        <h1>
          {/* {`${
            bankerData.theme === "team default"
              ? "Our clients have something to say."
              : "My clients have something to say."
          }`} */}
          Customer testimonials
        </h1>
        <p className="subtitle">
          {`${
            bankerData.team
              ? "See what our clients have experienced through their mortgage journey."
              : "See what my clients have experienced through their mortgage journey."
          }`}
        </p>
        <Button
          type="tertiary"
          buttonText="View all reviews"
          linkAttributes={{
            href: ratingData.microSite,
            target: "_blank",
            rel: "noreferrer",
            style: {
              display: "inline-flex",
            },
          }}
        />
      </Headlines>
      <div className="rating">
        <RatingCard
          rating={ratingData.score}
          reviewCount={ratingData.reviewCount}
          microSite={ratingData.microSite}
          locationId={ratingData.reputationId}
          dataLoaded={ratingData.dataLoaded}
        />
        <ConfettiWrapper>
          <Confetti />
        </ConfettiWrapper>
      </div>
    </Header>
  )
}

export default ReviewHeader
